<script lang="ts">
import { Tab, useTabsViewStore } from '@/store/modules/tabs'
import { DArrowLeft, WarningFilled } from '@element-plus/icons-vue'
import { notifier, operation, topTip } from './breadcrumb'

export default {
  name: 'LayoutBreadcrumb'
}
</script>
<script setup lang="ts">
const tabStore = useTabsViewStore()
const router = useRouter()
const route = useRoute()

const currentTab = computed(() => {
  return tabStore.getTabs.find((tab) => {
    return (
      tab.name === route.name || tab.visitedRecords.some((record) => record.path === route.path)
    )
  })
})

const breadcrumb = computed(() => {
  const title = route.meta.menuName ?? route.meta.title ?? ''
  const defaultList = title ? [title] : []
  return (
    unref(currentTab)?.visitedRecords.map((record) => {
      const { menuName = '', title = '' } = record.meta || {}
      return menuName || title
    }) ?? defaultList
  )
})

function handleBack() {
  const { parentMenu, replaceBack, onlyBack } = route.meta
  if (onlyBack) {
    router.back()
    return
  }
  if (replaceBack) {
    // 微应用嵌入，使用replace清除路由历史的影响
    parentMenu && router.replace(parentMenu as string)
  }
  const visitedRecords = unref(currentTab)?.visitedRecords
  if (!visitedRecords?.length) {
    return
  }

  if (visitedRecords?.length === 1) {
    const { parentMenu } = route.meta
    if (parentMenu) {
      router.push(parentMenu as string)
    }
    return
  }

  if (visitedRecords?.length > 1) {
    visitedRecords.pop()
    const lastRecord = visitedRecords[visitedRecords.length - 1]
    router.push({ path: lastRecord?.fullPath || '/' })
  }
}

const canTurnBack = computed(
  () =>
    route.meta?.parentMenu ||
    (unref(currentTab) as Tab)?.visitedRecords?.length > 1 ||
    route.meta?.onlyBack
)
/** 通知消息 */
const notification = computed(notifier.get)
/** 附加操作按钮 */
const AdditionButton = computed(operation.get)
/** 顶部提醒 */
const TopTip = computed(topTip.get)
watch(
  () => route.path,
  () => {
    // 路由变更时，清空通知和附加按钮
    notifier.clear()
    operation.clear()
    topTip.clear()
  }
)
</script>

<template>
  <!-- 头部提醒 -->
  <TopTip v-if="TopTip" />
  <div class="flex justify-between px-6 my-4 relative">
    <div class="flex items-center">
      <!-- 标题 -->
      <div class="flex text-base text-primary title-outline">
        {{ breadcrumb.join(' > ') }}
      </div>
      <!-- 通知消息 -->
      <div
        v-if="notification"
        class="ml-2 px-3 py-1 flex items-center border border-warning border-solid rounded-md bg-opacity-5 bg-warning cursor-pointer"
        @click="notifier.click"
      >
        <ElIcon :size="16" class="text-warning"><WarningFilled /></ElIcon>
        <span class="ml-2 mr-10">{{ notification }}</span>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="flex items-center">
      <!-- 自定义按钮 -->
      <AdditionButton v-if="AdditionButton" />
      <!-- 返回按钮 -->
      <div v-if="canTurnBack" class="flex items-center cursor-pointer" @click="handleBack()">
        <ElIcon><DArrowLeft color="#1761F1" /></ElIcon>
        <span class="text-[#1761F1]">返回上一页</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.title-outline {
  margin-left: 6px;
  position: relative;

  &::before {
    position: absolute;
    top: 50%;
    left: -6px;
    width: 2px;
    height: 16px;
    border-radius: 1px;
    background: #1761f1;
    transform: translateY(-50%);
    content: '';
  }
}
.top-tip {
  background: #e5f0ff;
  padding: 16px 24px;
  color: #333333;
}
</style>
